// Campus photo for /colleges/saint-louis-university: CC BY-SA 2.0, by w_lemay, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADuBourg_Hall%2C_Saint_Louis_University%2C_Grand_Avenue%2C_Midtown%2C_St._Louis%2C_MO.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/saint-louis-university/; credited under the photo.
const photo = {
    "slug": "saint-louis-university",
    "alt": "DuBourg Hall, a red brick Gothic building on Grand Avenue at Saint Louis University in St. Louis, Missouri",
    "src": "/colleges/saint-louis-university/campus-1600.webp",
    "srcSmall": "/colleges/saint-louis-university/campus-800.webp",
    "srcMid": "/colleges/saint-louis-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/saint-louis-university/og.jpg",
    "title": "DuBourg Hall, Saint Louis University, Grand Avenue, Midtown, St. Louis, MO",
    "author": "w_lemay",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADuBourg_Hall%2C_Saint_Louis_University%2C_Grand_Avenue%2C_Midtown%2C_St._Louis%2C_MO.jpg",
    "read": "2026-10-01"
};

export default photo;
